// extracted by mini-css-extract-plugin
export default {"navigation":"Navbar_navigation__xonxl","navigationButton":"Navbar_navigationButton__YJ5VO"};